import React, { useEffect, useRef, useState } from 'react';
import { FaHome } from 'react-icons/fa'


const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState(null);
    const dropdownRef = useRef(null);

    const handleMobileMenuToggle = () => {
        setIsMobileMenuOpen((prevIsMobileMenuOpen) => !prevIsMobileMenuOpen);
    };

    useEffect(() => {
        // Function to handle scroll events
        const handleScroll = () => {
          const sections = ['home', 'header', 'services', 'payment','feedback', 'contact'];
    
          // Determine which section is currently in view based on scroll position
          const inViewSection = sections.find((section) => {
            const element = document.getElementById(section);
            if (element) {
              const rect = element.getBoundingClientRect();
              return rect.top <= 0 && rect.bottom > 0;
            }
            return false;
          });
    
          // Update the active section
          setActiveSection(inViewSection);
        };
    
        // Attach the scroll event listener
        window.addEventListener('scroll', handleScroll);
    
        // Remove the event listener when the component is unmounted
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

    const scrollTo = (elementId) => {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
          });
          setActiveSection(elementId);
        }
      };

    return (
        <nav className={`text-white fixed top-0 left-0 w-full z-50`}>
            {/* Desktop Navbar */}
            <div className={`hidden md:flex items-center justify-between px-4 py-3 max-h-20 lg:px-32 ${activeSection === 'home' ? 'bg-opacity-50' : 'bg-gray-500 bg-opacity-80'}`}>
                <div className='rounded-lg' onClick={() => scrollTo('home')}>
                    <a href="#home" className="text-xl font-bold flex flex-row items-end gap-2">
                    <FaHome size={30}/> ANHS
                    </a>
                </div>
                <div className="ml-auto flex gap-2 font-bold">
                    {/* Use ml-auto to push links to the right */}
                    <a href="#aboutus" className="py-2 px-3 rounded-lg hover:bg-gray-950" onClick={() => scrollTo('aboutus')}>
                        About Us
                    </a>
                    <a href="#services" className="py-2 px-3 rounded-lg hover:bg-gray-950" onClick={() => scrollTo('services')}>
                        Services
                    </a>
                    <a href="#payment" className="py-2 px-3 rounded-lg hover:bg-gray-950" onClick={() => scrollTo('payment')}>
                        Payment
                    </a>
                    <a href="#feedback" className="px-3 py-2 rounded-lg hover:bg-gray-950" onClick={() => scrollTo('feedback')}>
                        Feedback
                    </a>
                    <a href="#contact" className="py-2 px-3 rounded-lg hover:bg-gray-950" onClick={() => scrollTo('contact')}>
                        Contact Us
                    </a>
                </div>
            </div>

            {/* Mobile Navbar */}
            <div className={`${activeSection === 'home' ? 'bg-gray-500' : 'bg-gray-500 bg-opacity-80'} block md:hidden py-3 px-2`}>
                <div className="flex items-center justify-between max-h-14">
                    <div>
                        <a href="/" className="text-xl font-bold flex flex-row gap-2 items-end">
                            <FaHome size={30}/> ANHS
                        </a>
                    </div>
                    <button
                        className="mobile-menu-button focus:outline-none px-1"
                        onClick={handleMobileMenuToggle}
                    >
                        <svg
                            className="w-10 h-8"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M4 6h16M4 12h16m-7 6h7"
                            />
                        </svg>
                    </button>
                </div>
                {/* Mobile Dropdown */}
                <div className={`mt-0 ${isMobileMenuOpen ? 'block' : 'hidden'} mx-4 text-center`} ref={dropdownRef}>
                    <a href="#aboutus" className="block py-2 hover:bg-gray-950" onClick={() => scrollTo('aboutus')}>
                        About Us
                    </a>
                    <a href="#services" className="block py-2 hover:bg-gray-950" onClick={() => scrollTo('services')}>
                        Services
                    </a>
                    <a href="#payment" className="block py-2 hover:bg-gray-950" onClick={() => scrollTo('payment')}>
                        Payment
                    </a>
                    <a href="#feedback" className="block py-2 hover:bg-gray-950" onClick={() => scrollTo('feedback')}>
                        Feedback
                    </a>
                    <a href="#contact" className="block py-2 hover:bg-gray-950" onClick={() => scrollTo('contact')}>
                       Contact Us
                    </a>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
